import React from 'react'
import { useTranslation } from 'react-i18next'
import useAudioManager from '../../../hooks/useAudioManager'
import { WITHDRAW_METHODS } from '../constants/withdrawMethods'

/**
 * WithdrawMethodSelector — выбор метода вывода кристаллов
 * Пока только Steam, но архитектура готова для добавления новых методов
 */
const WithdrawMethodSelector = ({ selectedMethod, availableMethods, onSelect }) => {
  const { t } = useTranslation()
  const { playSound } = useAudioManager({ pick: 'pick' })

  if (availableMethods.length <= 1) {
    // Если метод один — не показываем селектор
    return null
  }

  const getMethodIcon = (methodId) => {
    switch (methodId) {
      case WITHDRAW_METHODS.STEAM:
        return <img src="/images/payment/steam.png" alt="Steam" className="w-10 h-10" />
      case WITHDRAW_METHODS.UZS:
        return <img src="/images/payment/uzbekistan.png" alt="UZS" className="w-10 h-10 rounded-lg" />
      case WITHDRAW_METHODS.TJS:
        return <img src="/images/payment/tajikistan.png" alt="TJS" className="w-10 h-10 rounded-lg" />
      case WITHDRAW_METHODS.RUB_SBP:
        return <img src="/images/payment/sbp.png" alt="SBP" className="w-10 h-10" />
      case WITHDRAW_METHODS.RUB_CARD:
        return <img src="/images/payment/card-rub.png" alt="RUB" className="w-10 h-10" />
      case WITHDRAW_METHODS.CRYPTO:
        return <img src="/images/payment/crypto.png" alt="Crypto" className="w-10 h-10" />
      case WITHDRAW_METHODS.STARS:
        return <img src="/images/payment/star.png" alt="Telegram Stars" className="w-10 h-10" />
      default:
        return null
    }
  }

  const getMethodTitle = (methodId) => {
    switch (methodId) {
      case WITHDRAW_METHODS.STEAM:
        return t('withdraw.methods.steam', 'Steam')
      case WITHDRAW_METHODS.UZS:
        return t('withdraw.methods.uzs', 'Карта UZS')
      case WITHDRAW_METHODS.TJS:
        return t('withdraw.methods.tjs', 'Карта TJS')
      case WITHDRAW_METHODS.RUB_SBP:
        return t('rubWithdraw.methods.sbp')
      case WITHDRAW_METHODS.RUB_CARD:
        return t('rubWithdraw.methods.card')
      case WITHDRAW_METHODS.CRYPTO:
        return t('withdraw.methods.crypto', 'Криптовалюта')
      case WITHDRAW_METHODS.STARS:
        return t('starsWithdraw.method')
      default:
        return methodId
    }
  }

  return (
    <div className="mb-6">
      <h2 className="text-lg font-semibold mb-4">{t('withdraw.selectMethod', 'Способ вывода')}</h2>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {availableMethods.map((method) => {
          const isSelected = selectedMethod === method.id
          return (
            <button
              key={method.id}
              onClick={() => {
                playSound('pick')
                onSelect(method.id)
              }}
              className={`
                relative bg-surface rounded-lg p-4 text-start transition-all
                hover:scale-[1.02] active:scale-[0.98]
                ${isSelected
                  ? 'ring-2 ring-accent-primary border-accent-primary/50'
                  : 'border border-white border-opacity-10 hover:border-accent-primary/30'
                }
              `}
            >
              {isSelected && (
                <div className="absolute -top-4 end-[-0.5rem]">
                  <span className="inline-block px-2 py-0.5 bg-accent-primary text-dark-primary text-xs font-bold rounded-full">
                    {t('withdraw.selected', 'Выбрано')}
                  </span>
                </div>
              )}
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3">
                {getMethodIcon(method.id)}
              </div>
              <h3 className={`font-semibold ${isSelected ? 'text-accent-primary' : 'text-white'}`}>
                <bdi>{getMethodTitle(method.id)}</bdi>
              </h3>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default WithdrawMethodSelector
